export interface ResolvedClientResponse {
  citizenship: string;
  dateOfBirth: string;
  firstName: string;
  gender: string;
  lastName: string;
  middleName: string;
  tin: string;
  incapacitated: boolean;
}
